import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { ITruckImplementTireDataDTO } from 'app/shared/model/dto/truck-implement-tire-data-dto.model';
import { ITireTruckImplement } from 'app/shared/model/tire-truck-implement.model';
import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { cleanEntity } from 'app/shared/util/entity-utils';
import axios from 'axios';

const initialState = {
  loading: true,
  errorMessage: null,
  entities: [] as ITireTruckImplement[],
  /* entity: defaultValue, */
  truckImplementTireDataDTO: {} as ITruckImplementTireDataDTO,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type TireTruckImplementCustomState = Readonly<typeof initialState>;

const apiUrl = 'api/tire-truck-implements-custom';

// Actions

export const getTireTruckImplementCustomByTruckImplementId = createAsyncThunk(
  'getTireTruckImplementCustomByTruckImplementId/fetch_entity_list',
  async (truckImplementId: string | number) => {
    const requestUrl = `${apiUrl}/${truckImplementId}`;
    return axios.get<ITireTruckImplement[]>(requestUrl);
  }
);

export const getTruckImplementNumberOfTires = createAsyncThunk(
  'getTruckImplementNumberOfTires/fetch_entity',
  async (truckImplementId: string | number) => {
    const requestUrl = `${apiUrl}/number-of-tires/${truckImplementId}`;
    return axios.get<ITruckImplementTireDataDTO>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

export const saveAllTireTireTruckImplements = createAsyncThunk(
  'createTireTruckImplement/create_entity',
  async (entities: ITireTruckImplement[], thunkAPI) => {
    const result = await axios.post<ITireTruckImplement[]>(`${apiUrl}/save-all`, entities.map(cleanEntity));
    const truckImplementId = entities[0].truckImplement?.id;
    if (truckImplementId != null) {
      thunkAPI.dispatch(getTireTruckImplementCustomByTruckImplementId(truckImplementId));
    }
    return result;
  },
  { serializeError: serializeAxiosError }
);

// slice

export const TireTruckImplementCustomSlice = createSlice({
  name: 'tireTruckImplementCustom',
  initialState: initialState as TireTruckImplementCustomState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getTruckImplementNumberOfTires.fulfilled, (state, action) => {
        state.truckImplementTireDataDTO = action.payload.data;
      })
      .addCase(getTireTruckImplementCustomByTruckImplementId.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = action.payload.data;
      })
      .addMatcher(isFulfilled(saveAllTireTireTruckImplements), state => {
        state.updating = false;
        state.loading = true;
        state.updateSuccess = true;
      })
      .addMatcher(isPending(getTruckImplementNumberOfTires, getTireTruckImplementCustomByTruckImplementId), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isPending(saveAllTireTireTruckImplements), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
        state.loading = true;
      })
      .addMatcher(
        isRejected(getTruckImplementNumberOfTires, getTireTruckImplementCustomByTruckImplementId, saveAllTireTireTruckImplements),
        state => {
          state.loading = false;
          state.updating = false;
          state.updateSuccess = false;
        }
      );
  },
});

export const { reset } = TireTruckImplementCustomSlice.actions;

// Reducer
export default TireTruckImplementCustomSlice.reducer;
